import { render, staticRenderFns } from "./PointsOrder.vue?vue&type=template&id=7f4ddc9c"
import script from "./PointsOrder.vue?vue&type=script&lang=js"
export * from "./PointsOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports